import Statuses from './Statuses';
import StatusesContainer from './Statuses.container';

export default StatusesContainer(Statuses);
